import React from 'react';

import {
    Container,
    Header,
    Content
} from './styles';

interface IFeedCard {
    content : string;
    createData : string;
    userName : string;
}

function parseData(data : any, timezone : string) {
    const date = new Date(String(data));
    const timeFormat: Intl.DateTimeFormatOptions = { month: '2-digit', day: '2-digit', year: '2-digit', timeZone: timezone, hour: '2-digit', minute: '2-digit' };
    let result : string = date.toLocaleString('pt-BR', timeFormat);
    return result;
}

const FeedCard : React.FC<IFeedCard> = ({
    content,
    createData,
    userName
}) => {

    const dataCriacao = parseData(createData, 'America/Sao_Paulo');

    return (
        <Container>
            <Header>
                {userName} - {dataCriacao}
            </Header>
            <Content>
                <textarea readOnly value={content} />
            </Content>
        </Container>
    )
}

export default FeedCard;